<template>
    <div>
        <div class="text-center" style="font-family:Sans-serif">
            <center>
                <v-overlay v-model="overlay">
                    <v-progress-circular
                        indeterminate
                        :size="120"
                        :width="3"
                    ></v-progress-circular><br>Loading, please wait...
                </v-overlay>
            </center>
        </div>
        
        <v-card flat>
            <v-card-text>

            <v-row>
                <v-col cols="1.5">
                    <v-toolbar flat>
                        <v-toolbar-title>
                            <span style="font-size: 15px !important;" class="overline font-weight-bold"> <v-icon class="mb-5" color="black" x-large>mdi-human-male-board-poll</v-icon>Give us your FeedBack....</span>
                        </v-toolbar-title>
                    </v-toolbar>
                    
                </v-col>
                <v-col cols="3">
                        <v-text-field
                        v-model="search"
                        width="100px"
                        clearable
                        tile
                        persistent-placeholder
                        placeholder="Search for Feedback No."
                        dense
                        class="mr-2"
                        outlined
                        ></v-text-field>
                </v-col>

                <v-col cols="3">
                        <v-autocomplete
                        label="依頼内容:"
                        @change="filterFeedback()"
                        v-model="requestContent"
                        :items="requestContentList"
                        clearable
                        tile
                        class="mr-2"
                        dense
                        outlined
                        ></v-autocomplete>
                </v-col>

                <v-col cols="2">
                        <v-autocomplete
                        v-model="replyStatusFilter"
                        @change="filterFeedback()"
                        label="Reply Status:"
                        clearable
                        :items="replyStatus"
                        class="mr-2"
                        dense
                        tile
                        outlined
                        ></v-autocomplete> 
                </v-col>

                <v-col cols="1">
                    <!-- <v-divider small class="ma-2" vertical /> -->
                    <v-btn color="primary"
                        @click="toggleDialogNewFeedback(true)"
                    >New<v-icon>mdi-help-circle</v-icon></v-btn
                    >
                </v-col>
                <v-col cols="1.5"></v-col>
            </v-row>

            <v-row>
                <template v-for="(item, ii) in searchInFeedbackTable">
                        <v-col cols="4" :key="ii">
                            <template>
                                <v-card>
                                    <v-toolbar dark color="blue-grey darken-4" v-if="item.reply_status == null">
                                        <v-toolbar-title>
                                                <v-icon class="notifAnimation" large color="red" v-if="item.created_at.slice(0,10) == createdDate">mdi-alert-octagram-outline</v-icon>
                                            <span class="overline font-weight-bold">Feedback No: {{ item.feedback_number }}
                                                <v-icon @click="openDeleteDialog(item.id)" color="red">mdi-trash-can-outline</v-icon>
                                            </span>
                                        </v-toolbar-title>
                                    </v-toolbar>
                                    <v-toolbar  v-else-if="item.reply_status == 1" color="#04b8f7">
                                        <v-toolbar-title>
                                            <span class="overline font-weight-bold">Feedback No: {{ item.feedback_number }}
                                                <v-icon @click="openDeleteDialog(item.id)" color="red">mdi-trash-can-outline</v-icon>
                                            </span>
                                        </v-toolbar-title>
                                    </v-toolbar>
                                <v-card-text>

                                    <!-- FEEDBACK -->
                                    <v-card-title class="mb-2">{{ item.request_content }}</v-card-title>
                                    <v-card-subtitle>
                                        {{ item.concerns }}
                                    </v-card-subtitle>
                                    <span class="overline">
                                        Customer Code : <b>{{ item.feedback_customer_code }}&nbsp;&nbsp;{{ item.revision_number }}</b>
                                    </span><br>
                                    <span class="overline">
                                        Received Date/Time : <b>{{ item.requested_date }} - {{ formatTime(item.requested_time) }}</b>
                                    </span><br>
                                    <span class="overline">
                                        Feedback By: <b>{{item.name}}</b> ({{item.created_at  | formatDate}})
                                    </span><br/>

                                        <span class="overline" v-for="(att, iii) in item.attachments" :key="iii">
                                            Attachment: {{att.filename}} 
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon @click="downloadAttachment(att.id)" v-bind="attrs" v-on="on" color="green">mdi-download</v-icon>&nbsp;
                                                    </template>
                                                    <span>Download</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon @click="openAttachment(att.id)" v-bind="attrs" v-on="on" color="primary">mdi-eye</v-icon>&nbsp;
                                                    </template>
                                                    <span>Preview</span>
                                                </v-tooltip>
                                        </span>
                                    <!-- END OF FEEDBACK -->

                                    <!-- REPLIES -->
                                    <template>
                                        <v-row justify="center">
                                            <v-expansion-panels v-model="repliesPanel" multiple inset height="500px">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="overline">Reply Details : </v-expansion-panel-header>
                                                    <v-expansion-panel-content>
                                                        <!-- {{ feedbackData[ii].reply }} -->
                                                        <v-row v-if="item.reply.length > 0">
                                                            <v-col>
                                                                <span class="overline text--bold" v-for="(reply, iiii) in item.reply" :key="iiii">
                                                                    <b>({{ reply.created_at | formatDate}})
                                                                    Reply from {{ reply.replied_by }} :</b> {{ reply.reply_details }}<br>
                                                                    <div  v-show="reply.reply_attachments.length > 0">
                                                                        <span class="overline" v-for="(att, iii) in reply.reply_attachments" :key="iii">
                                                                            Attachments: <b style="color: blue;">{{att.file_name}} </b>
                                                                                <v-tooltip bottom>
                                                                                    <template v-slot:activator="{ on, attrs }">
                                                                                        <v-icon @click="downloadReplyAttachment(att.id)" v-bind="attrs" v-on="on" color="green">mdi-download</v-icon>
                                                                                    </template>
                                                                                    <span>Download</span>
                                                                                </v-tooltip>
                                                                                <v-tooltip bottom>
                                                                                    <template v-slot:activator="{ on, attrs }">
                                                                                        <v-icon @click="openReplyAttachment(att.id)" v-bind="attrs" v-on="on" color="primary">mdi-eye</v-icon>
                                                                                    </template>
                                                                                    <span>Preview</span>
                                                                                </v-tooltip>
                                                                        </span><br>
                                                                    </div>
                                                                </span>
                                                            </v-col>
                                                        </v-row>
                                                        <v-divider></v-divider>
                                                        <v-row style="margin-bottom: -40px !important;" v-show="loggedInUser.is_admin == 1">
                                                            <v-col cols="3" class="text-right">
                                                                <span class="overline">Reply :</span>
                                                            </v-col>
                                                            <v-col>
                                                                <v-textarea v-model="item.replyContent" class="overline" rows="4" outlined dense></v-textarea>
                                                            </v-col>
                                                            <v-col cols="1" class="mr-2">
                                                                <v-btn icon @click="saveReply(item)">
                                                                    <v-icon color="primary">mdi-send</v-icon>
                                                                </v-btn>
                                                                <v-btn icon @click="replyAttach(item)">
                                                                    <v-icon color="black">mdi-paperclip</v-icon>
                                                                </v-btn>
                                                            </v-col>
                                                        </v-row>
                                                    </v-expansion-panel-content>
                                            </v-expansion-panel>
                                            </v-expansion-panels>
                                        </v-row>
                                    </template>
                                    <!-- END OF REPLIES -->
                                </v-card-text>
                                </v-card>
                            </template>
                        </v-col>
                </template>
            </v-row>
            </v-card-text>
        </v-card>

        <v-dialog v-model="deleteFeedbackDialog" width="20%" persistent>
            <v-card>
                <!-- <v-card-title>
                    <span class="overline">DELETE FEEDBACK</span>
                </v-card-title><v-spacer/> -->
                <v-card-text>
                    <v-toolbar flat class="overline">
                        <span><b>Are you sure you want to delete this feedback ?</b></span>
                    </v-toolbar>
                </v-card-text>
                <v-card-actions><v-spacer/>
                    <v-btn color="success" @click="deleteFeedback()" dark depressed width="105px">Yes</v-btn>
                    <v-btn @click="closeDelete()" depressed color="#E74C3C" class="white--text" width="105px">キャンセル</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="replyAttachmentDialog" width="20%" persistent>
            <v-card>
                <v-card-title>
                    <span class="overline">REPLY ATTACHMENT</span>
                </v-card-title><v-spacer/>
                <v-card-text><br>
                    <v-toolbar flat class="overline">
                        <v-file-input label="Attachment here" v-model="file" @change="fileChange(file)" multiple outlined dense></v-file-input>
                    </v-toolbar>
                </v-card-text>
                <v-card-actions><v-spacer/>
                    <v-btn color="success" @click="closeReplyAttachmentDialog()" dark depressed width="105px">Yes</v-btn>
                    <v-btn @click="closeReplyAttachmentDialog()" depressed color="#E74C3C" class="white--text" width="105px">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <dialog-new-feedback
            @filterFeedback="filterFeedback"
            @toggleDialogNewFeedback="toggleDialogNewFeedback"
            :dialog="dialogNewFeedback"
        ></dialog-new-feedback>
    </div>
</template>

<script>
import DialogNewFeedback from '../main-page-modules/DialogNewFeedback.vue';
import { mapState } from 'vuex';
import moment from 'moment-timezone';

export default {
        
    components: {
        'dialog-new-feedback': DialogNewFeedback,
    },
        data(){
            return {
                createdDate : (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                file: null,
                replyAttachmentDialog: false,
                reply_attachments: [],
                deleteDataId: null,
                deleteFeedbackDialog: false,
                requestContent: null,
                replyStatusFilter: null,
                search: '',
                reply: null,
                repliesPanel: [0],
                dialogNewFeedback: false,
                feedbackData: [],
                overlay : false,

                requestContentList: [
                    "CAD依頼システムエラー",
                    "CAD依頼システムの改善提案",
                    // "CAD依頼のキャンセル",
                    "SRS(仕様検討ツール依頼システム)エラー",
                    "SRS(仕様検討ツール依頼システムの)改善提案"
                ],
                replyStatus: [
                    "ALL",
                    "REPLIED",
                    "NOT YET REPLIED"
                ],

            }
        },

        computed:{
            ...mapState([
                // 'cadRequestVersion',
                'loggedInUser'
            ]),
            searchInFeedbackTable(){
                return this.feedbackData.filter((data) => {
                    let searchData = new RegExp(this.search.toUpperCase(), "g");
                        return JSON.stringify(Object.values(data)).toUpperCase().match(searchData);
                });
            },
        },
        filters: {
            formatDate(value) {
                if (value != null) {
                    // Create a new Date object from the ISO 8601 string
                    const localDate = new Date(value);
                    
                    // Check if the date is valid
                    if (!isNaN(localDate.getTime())) {
                        // Return the local date in the desired format (e.g., 'YYYY-MM-DD')
                        return localDate.toLocaleDateString('en-CA'); // 'en-CA' gives 'YYYY-MM-DD' format
                    } else {
                        console.error("Invalid date:", value);
                        return ''; // Return an empty string or handle the error as needed
                    }
                }
                return '';
                // const localDate = new Date(value);
                // console.log(localDate.toLocaleDateString(),'localDate')
                // if(value != null){
                //     return value.split("T")[0];
                // }
            }
        },

        methods: {
            formatTime(time) {
                if(time){
                    // console.log(time,'timeee')
                    const [hours, minutes] = time.split(':');
                    const formattedHours = hours.padStart(2, '0');
                    const ampm = parseInt(formattedHours, 10) >= 12 ? 'PM' : 'AM';
                    return `${formattedHours}:${minutes} ${ampm}`;
                } else {
                    return '';
                }
                
            },

            replyAttach(){
                this.replyAttachmentDialog = true;
            },
            closeReplyAttachmentDialog(){
                this.replyAttachmentDialog = false;
            },
            fileChange(tempVariable){
                this.reply_attachments = [];
                    if(tempVariable){
                        tempVariable.forEach(async (item) => {
                            const reader = new FileReader();
                            reader.readAsDataURL(item);
                                reader.onloadend = () => {
                                    this.reply_attachments.push({
                                        data: reader.result,
                                        name: item.name,
                                    });

                                };
                                
                            })
                    }
            },

            // replyAttach(item){
            //     console.log(item.id,'id')
            // },

            closeDelete(){
                this.deleteFeedbackDialog = false;
                this.deleteDataId = null;
            },
            openDeleteDialog(item){
                this.deleteFeedbackDialog = true;
                this.deleteDataId = item
            },
            deleteFeedback(){
                axios({
                    method: "POST",
                    url: "api/deleteFeedbackData",
                    data: {id : this.deleteDataId}
                }).then(({data}) => {
                    this.filterFeedback()
                    this.closeDelete();
                })
            },
            filterFeedback(){
                this.overlay = true;
                axios({
                    method: "POST",
                    url: "api/getFeedbackData",
                    data: {
                        replyStatus : this.replyStatusFilter,
                        requestContent : this.requestContent,
                    }
                }).then(({data}) => {
                    this.feedbackData = data;
                    this.overlay = false;
                })
            },
            openReplyAttachment(id){
                window.open(`viewReplyAttachment/${id}`, '_blank');
            },
            downloadReplyAttachment(id){
                window.open(`downloadReplyAttachment/${id}`, '_blank');
            },
            openAttachment(id){
                window.open(`viewFeedbackAttachment/${id}`, '_blank');
            },
            downloadAttachment(id){
                window.open(`downloadAttachment/${id}`, '_blank');
            },
            saveReply(item){
                var formdata = new FormData();
                formdata.append("files", JSON.stringify(this.reply_attachments));
                formdata.append('data', JSON.stringify(item))
                axios({
                    method: "POST",
                    url: "api/saveReply",
                    data: formdata
                }).then(({data}) => {
                    console.log(data)
                    this.reply = null;
                    this.file = null;
                    this.filterFeedback();
                    this.reply_attachments = []
                    // this.replyEmailNotif(item);
                    
                })
            },
            // NO NEED TO USE SENDING OF EMAIL AS PER ADVISED
            // replyEmailNotif(item){
                // let currentTimezone = moment.tz.guess(true);
                // let tokyoTimezone = moment.tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss");
                // let dateReplied = currentTimezone == "Asia/Tokyo" ? tokyoTimezone : moment().format("YYYY-MM-DD HH:mm:ss");

                // var message = `Your feedback has been replied.
                // <br><p><b>Feedback Details: </b></p><p><b>依頼内容:  </b><span>   </span>${item.request_content} </p><p><b>フィードバック番号:
                // </b><span>   </span>${item.feedback_number} </p><br><span>----------------------------------------------</span><p><b>Reply Details:  </b></p><p><b>Reply:  </b><span>   </span>${item.replyContent}</p><p><b>Date Replied: </b><span>   </span>${dateReplied} (${currentTimezone})</p><p>
                // Please Check Cad Request System :
                // </p><a href="https://cadrequestv2.hrd-s.com/feedBack">Cad Request System V2.${this.$store.state.cadRequestVersion.version}</a><br><p><b>Thank You.<b/></p><p>*Please do not reply to this email. This is an auto-generated email.</p>`;
                // window.open(`email-form/${message}`, '_blank').focus();
                // window.open(`email-form/${message}`, '_blank').focus();


                // var message = {
                //     header : 'Your feedback has been replied.',
                //     request_content: item.request_content,
                //     feedback_number: item.feedback_number,
                //     replyContent: item.replyContent,
                //     dateReplied: dateReplied,
                //     currentTimezone: currentTimezone,
                //     version: this.$store.state.cadRequestVersion.version,
                //     senderEmail: 'cad-request-v2',
                //     to: item.email,
                //     cc: ["r-quinto@hrd-s.com"],
                //     From : ["cad-requestv2@hrd-ihs.com"]

                // };
                // axios({
                //     method: 'post',
                //     url: `/email-form`,
                //     data: message
                // }).then(({data}) => {
                //     console.log(data)
                // })
                // return;

                // this.sendEmailNotif(
                //     ["cad-requestv2@hrd-ihs.com"],
                //     [item.email],
                //     ["r-quinto@hrd-s.com"],
                //     message,
                //     []
                // );
            // },
            // sendEmailNotif(from,to,cc,message,attachment){
            //         let obj = {
            //             from: 'cad-request-v2',
            //             senderEmail: from,
            //             to: to,
            //             cc: cc,
            //             subject: `CAD Request System V2 Feedback`,
            //             message: message,
            //             attachment: attachment,
            //         }

            //         axios({
            //             "method" : "POST",
            //             "url": "api/email-form",
            //             data: obj
            //         }).then((res) => {
            //             console.log(res.data)
            //         }).catch((err) => {
            //             console.log(err)
            //         })
            //     },

            getFeedbacks(){
                axios({
                    method: "GET",
                    url: "api/getFeedbackData"
                }).then(({data}) => {
                    this.feedbackData = data;
                })
            },
            toggleDialogNewFeedback(value){
                if(value){
                    this.dialogNewFeedback = true;
                }else{
                    this.dialogNewFeedback = false;
                }
                
            },

        },
        mounted(){
            this.replyStatusFilter = "NOT YET REPLIED"
            this.filterFeedback();
            console.log(this.feedbackData,'getFeedbacks')
        },
    }
</script>
<style scoped>

.notifAnimation{
    opacity: 1;
    animation: fade 2s linear;
    animation-iteration-count: infinite;
}

@keyframes fade {
    0%,100% { opacity: 0 }
    50% { opacity: 1 }
}
</style>